module.exports = __webpack_public_path__ + "media/smart.fbd0daec.mp4";